module.exports = __webpack_public_path__ + "img/tagline.fcc88f81.svg";